import ExploreSection from "components/home/landing-components/explore";
import Footer from "components/home/landing-components/footer";
import Header from "components/home/landing-components/header";
import Hero from "components/home/landing-components/hero";
import RecentMilestoneSection from "components/home/landing-components/recents-milestones";
import VideoHomePage from "components/home/landing-components/video";
import FooterPremium from "components/subscription/footer-premium";
import { SubscriptionContext } from "context/subscription";
import {useContext} from "react";

export default function HomePage() {
  const { subscription, isSubscribed } = useContext(SubscriptionContext);
  return (
    <div className="bg-white relative">
      <Header />
      <Hero />
      <ExploreSection />
      <RecentMilestoneSection />
      <VideoHomePage/>
      <Footer />
      {
        ((subscription?.name === 'Free Account' || subscription === null) && !isSubscribed) && 
        <div className={`fixed bottom-0 left-0 w-full z-50`}>
          <FooterPremium
            shshowSecondPremow = {true}
            isFromLandingPage = {true}
            />
        </div>
      }
    </div>
  );
}